// extracted by mini-css-extract-plugin
var _1 = "AnswerStack_cardWrapper__844d0";
var _2 = "AnswerStack_navButtonLeft__2d0ac";
var _3 = "AnswerStack_navButtonRight__6b45b";
var _4 = "AnswerStack_stackContainer__1fc79";
var _5 = "AnswerStack_stackWrapper__1f676";
export { _1 as "cardWrapper", _2 as "navButtonLeft", _3 as "navButtonRight", _4 as "stackContainer", _5 as "stackWrapper" }
